import { createSelector } from "reselect";

export const getAllFeatureFlags = (state) => state.feature_flags;

export const getFeatureFlag = createSelector(
  getAllFeatureFlags,
  (state, name) => name,
  (flags, name) => flags && flags.includes(name)
);
